import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { DragulaModule } from 'ng2-dragula';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { OAuthModule } from 'angular-oauth2-oidc';
import { SocialLoginModule, SocialAuthServiceConfig } from '@abacritt/angularx-social-login';
import {
    GoogleLoginProvider,
    FacebookLoginProvider
} from '@abacritt/angularx-social-login';

//import { SharedModule } from "./shared/shared.module";

import { AppRoutingModule } from './app-routing.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ToastrModule } from 'ngx-toastr';
import { ImageCropperModule } from 'ngx-image-cropper';
import { QuillModule } from 'ngx-quill';
import { NgPipesModule } from 'ngx-pipes';

import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatBadgeModule } from '@angular/material/badge';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
//import { MatNativeDateModule } from '@angular/material/';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
//import { MatRippleModule } from '@angular/material/ri';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSliderModule } from '@angular/material/slider';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTreeModule } from '@angular/material/tree';

import { HeaderComponent } from './shared/components/header/header.component';
import { SearchComponent } from './shared/components/header/elements/search/search.component';
import { MegaMenuComponent } from './shared/components/header/elements/mega-menu/mega-menu.component';
import { LanguagesComponent } from './shared/components/header/elements/languages/languages.component';
//import { NotificationComponent } from './shared/components/header/elements/notification/notification.component';
import { BookmarkComponent } from './shared/components/header/elements/bookmark/bookmark.component';
import { CartComponent } from './shared/components/header/elements/cart/cart.component';
import { MessageBoxComponent } from './shared/components/header/elements/message-box/message-box.component';
import { FooterComponent } from './shared/components/footer/footer.component';
import { BreadcrumbComponent } from './shared/components/breadcrumb/breadcrumb.component';
import { CustomizerComponent } from './shared/components/customizer/customizer.component';
import { FeatherIconsComponent } from './shared/components/feather-icons/feather-icons.component';
import { ContentComponent } from './shared/components/layout/content/content.component';
import { FullComponent } from './shared/components/layout/full/full.component';
import { LoaderComponent } from './shared/components/loader/loader.component';
import { SidebarComponent } from './shared/components/sidebar/sidebar.component';
import { TapToTopComponent } from './shared/components/tap-to-top/tap-to-top.component';

// Directives
import { DisableKeyPressDirective } from './shared/directives/disable-key-press.directive';
import { OnlyAlphabetsDirective } from './shared//directives/only-alphabets.directive';
import { OnlyNumbersDirective } from './shared//directives/only-numbers.directive';
import { ShowOptionsDirective } from './shared//directives/show-options.directive';
// Services
import { ChatService } from './shared//services/chat.service';
import { LayoutService } from './shared//services/layout.service';
import { NavService } from './shared//services/nav.service';
import { TableService } from './shared//services/table.service';
import { NgbdSortableHeader } from './shared//directives/NgbdSortableHeader';
import { DecimalPipe } from '@angular/common';
import { SubNavComponent } from './shared//components/sub-nav/sub-nav.component';

import { MyAccountComponent } from './shared/components/header/elements/my-account/my-account.component';
import { ConnectionListComponent } from './shared/components/connection-list/connection-list.component';
import { TrainingBoxComponent } from './shared/components/training-box/training-box.component';

import { NgxMatIntlTelInputComponent } from 'ngx-mat-intl-tel-input';
import { NgOtpInputModule } from 'ng-otp-input';

import { CommonService } from './services/common.service';
import { ArticlesService } from './services/articles.service';
import { AuthenticationService } from './services/authentication.service';
import { DiscussionsService } from './services/discussions.service';
import { DocumentService } from './services/document.service';
import { EventEmitterService } from './services/event-emitter.service';
import { FeedbackService } from './services/feedback.service';
import { FollowersService } from './services/followers.service';
import { FormsService } from './services/forms.service'
import { GroupsService } from './services/groups.service'
import { InternalRequestService } from './services/internal-request.service';
import { PostsService } from './services/posts.service';
import { ProfileService } from './services/profile.service';
import { RequestService } from './services/request.service';
import { ServicesService } from './services/services.service';
import { StaticService } from './services/static.service';
import { SupportService } from './services/support.service';
import { ContactUsService } from './services/contact-us.service';
// // for HttpClient import:
import { LoadingBarHttpClientModule } from '@ngx-loading-bar/http-client';
// // for Router import:
import { LoadingBarRouterModule } from '@ngx-loading-bar/router';
// // for Core import:
import { LoadingBarModule } from '@ngx-loading-bar/core';

import { AuthService } from './shared/services/firebase/auth.service';
import { AdminGuard } from './shared/guard/admin.guard';
import { SecureInnerPagesGuard } from './shared/guard/SecureInnerPagesGuard.guard';
import { CookieService } from 'ngx-cookie-service';
import { AngularFireModule } from "@angular/fire/compat";
import { AngularFireAuthModule } from "@angular/fire/compat/auth";

import { environment } from '../environments/environment';
import { AngularFirestoreModule } from '@angular/fire/compat/firestore';

import { AppComponent } from './app.component';
import { LoginComponent } from './auth/login/login.component';

import { OverlayModule } from '@angular/cdk/overlay';
import { RegisterFormComponent } from './auth/register-form/register-form.component';
import { AuthIndexComponent } from './auth/auth-index/auth-index.component';
import { ArticlesAllComponent } from './views/articles/articles-all/articles-all.component';
import { ArticlesDetailComponent } from './views/articles/articles-detail/articles-detail.component';
import { ArticlesCreateComponent } from './views/articles/articles-create/articles-create.component';
import { LoginEmailComponent } from './auth/login-email/login-email.component';
import { LinkedinResponseComponent } from './auth/linkedin-response/linkedin-response.component';
import { ContactUsComponent } from './auth/contact-us/contact-us.component';
import { ReachUsComponent } from './views/others/reach-us/reach-us.component';
import { FeedbackDashboardComponent } from './views/feedback/feedback-dashboard/feedback-dashboard.component';
import { FeedbackDetailComponent } from './views/feedback/feedback-detail/feedback-detail.component';
import { FeedbackSubmitComponent } from './views/feedback/feedback-submit/feedback-submit.component';
import { RequestAdminAllComponent } from './views/request/request-admin-all/request-admin-all.component';
import { RequestAdminDetailComponent } from './views/request/request-admin-detail/request-admin-detail.component';
import { RequestDashboardComponent } from './views/request/request-dashboard/request-dashboard.component';
import { RequestDetailComponent } from './views/request/request-detail/request-detail.component';
import { RequestSubmitComponent } from './views/request/request-submit/request-submit.component';
import { RequestSubmitProfileComponent } from './views/request/request-submit-profile/request-submit-profile.component';
import { RequestSubmitSupportComponent } from './views/request/request-submit-support/request-submit-support.component';
import { DiscussionsActiveUsersComponent } from './views/discussions/discussions-active-users/discussions-active-users.component';
import { DiscussionsAllComponent } from './views/discussions/discussions-all/discussions-all.component';
import { DiscussionsDetailComponent } from './views/discussions/discussions-detail/discussions-detail.component';
import { DiscussionsSubmitComponent } from './views/discussions/discussions-submit/discussions-submit.component';
import { FormsAllComponent } from './views/forms/forms-all/forms-all.component';
import { FormsViewComponent } from './views/forms/forms-view/forms-view.component';
import { GroupsAllComponent } from './views/groups/groups-all/groups-all.component';
import { GroupsAll2Component } from './views/groups/groups-all2/groups-all2.component';
import { GroupsDetailComponent } from './views/groups/groups-detail/groups-detail.component';
import { GroupsResourceListComponent } from './views/groups/groups-resource-list/groups-resource-list.component';
import { GroupsUserListComponent } from './views/groups/groups-user-list/groups-user-list.component';
import { NewsFeedComponent } from './views/newsfeed/news-feed/news-feed.component';
import { NotificationComponent } from './views/newsfeed/notification/notification.component';
import { PostComponent } from './views/newsfeed/post/post.component';
import { ProfileCertificatesComponent } from './views/profile/profile-certificates/profile-certificates.component';
import { ProfileChangePasswordComponent } from './views/profile/profile-change-password/profile-change-password.component';
import { ProfileChangeProfilePicturesComponent } from './views/profile/profile-change-profile-pictures/profile-change-profile-pictures.component';
import { ProfileConnectionsComponent } from './views/profile/profile-connections/profile-connections.component';
import { ProfileEditComponent } from './views/profile/profile-edit/profile-edit.component';
import { ProfileMyprofileComponent } from './views/profile/profile-myprofile/profile-myprofile.component';
import { ProfileUserDataComponent } from './views/profile/profile-user-data/profile-user-data.component';
import { ServicesDashboardComponent } from './views/services/services-dashboard/services-dashboard.component';
import { ServicesSdrDetailsComponent } from './views/services/services-sdr-details/services-sdr-details.component';
import { ServicesMandaysSummaryComponent } from './views/services/services-mandays-summary/services-mandays-summary.component';
import { ServicesNewSdrComponent } from './views/services/services-new-sdr/services-new-sdr.component';
import { ServicesPoComponent } from './views/services/services-po/services-po.component';
import { ServicesSdrsComponent } from './views/services/services-sdrs/services-sdrs.component';
import { StaticPageComponent } from './views/static/static-page/static-page.component';
import { StoreInfoComponent } from './views/store/store-info/store-info.component';
import { SupportCaseDetailComponent } from './views/support/support-case-detail/support-case-detail.component';
import { SupportCasesComponent } from './views/support/support-cases/support-cases.component';
import { SupportCaseSummaryComponent } from './views/support/support-case-summary/support-case-summary.component';
import { SupportDashboardComponent } from './views/support/support-dashboard/support-dashboard.component';
import { SupportGridComponent } from './views/support/support-grid/support-grid.component';
import { SupportInstantHelpComponent } from './views/support/support-instant-help/support-instant-help.component';
import { SupportNewAdvancedCaseComponent } from './views/support/support-new-advanced-case/support-new-advanced-case.component';
import { SupportNewCaseComponent } from './views/support/support-new-case/support-new-case.component';
import { PostListComponent } from './shared/components/post-list/post-list.component';

import { ProfileEditBoxComponent } from './shared/components/profile-edit-box/profile-edit-box.component';
import { ArticlesBoxComponent } from './shared/components/articles-box/articles-box.component';
import { DiscussionsBoxComponent } from './shared/components/discussions-box/discussions-box.component';
import { ConnectionsBoxComponent } from './shared/components/connections-box/connections-box.component';
import { FollowerBoxComponent } from './shared/components/follower-box/follower-box.component';
import { InternalRequestDetailsComponent } from './views/gistec/internal-request/internal-request-details/internal-request-details.component';
import { InternalRequestListComponent } from './views/gistec/internal-request/internal-request-list/internal-request-list.component';
import { InternalRequestSubmitComponent } from './views/gistec/internal-request/internal-request-submit/internal-request-submit.component';
import { GistecDashboardComponent } from './views/gistec/gistec-dashboard/gistec-dashboard.component';
import { DocumentListComponent } from './views/gistec/document/document-list/document-list.component';
import { UploadDocumentComponent } from './views/gistec/document/upload-document/upload-document.component';
import { ContactSearchComponent } from './views/gistec/contact/contact-search/contact-search.component';
import { DocumentDetailComponent } from './views/gistec/document/document-detail/document-detail.component';
import { DocumentShareToComponent } from './views/gistec/document/document-share-to/document-share-to.component';
import { NotificationBoxComponent } from './shared/components/notification-box/notification-box.component';
import { TagInputModule } from 'ngx-chips';
import { AccessDeniedComponent } from './shared/components/access-denied/access-denied.component';
import { GoogleResponseComponent } from './auth/google-response/google-response.component';
import { ContinueWithComponent } from './auth/continue-with/continue-with.component';
import { SharedDocumentsComponent } from './views/newsfeed/shared-documents/shared-documents.component';
import { SharedDocumentDetailComponent } from './views/newsfeed/shared-document-detail/shared-document-detail.component';
import { RedirectDocumentComponent } from './views/redirect/redirect-document/redirect-document.component';
import { SupportNewStandardComponent } from './views/support/support-new-standard/support-new-standard.component';
import { LoginAsComponent } from './auth/login-as/login-as.component';
import { LoginAsMessageComponent } from './shared/components/header/elements/login-as-message/login-as-message.component';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, "./assets/i18n/", ".json");
}

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    RegisterFormComponent,
        AuthIndexComponent,
        ShowOptionsDirective,
        DisableKeyPressDirective,
        OnlyAlphabetsDirective,
        OnlyNumbersDirective,
        NgbdSortableHeader,
        SubNavComponent,
    ArticlesAllComponent,
    ArticlesDetailComponent,
    ArticlesCreateComponent,
        LoginEmailComponent, FooterComponent,
        LinkedinResponseComponent,
        ContactUsComponent, FeatherIconsComponent,
        HeaderComponent, SearchComponent, MegaMenuComponent, LanguagesComponent, BookmarkComponent, CartComponent, MessageBoxComponent,
        BreadcrumbComponent,
        CustomizerComponent,
        FeatherIconsComponent,
        ContentComponent,
        FullComponent,
        LoaderComponent,
        SidebarComponent,
        TapToTopComponent,   
    ReachUsComponent,
    FeedbackDashboardComponent,
    FeedbackDetailComponent,
    FeedbackSubmitComponent,
    RequestAdminAllComponent,
    RequestAdminDetailComponent,
    RequestDashboardComponent,
    RequestDetailComponent,
    RequestSubmitComponent,
    RequestSubmitProfileComponent,
    RequestSubmitSupportComponent,
    DiscussionsActiveUsersComponent,
    DiscussionsAllComponent,
    DiscussionsDetailComponent,
    DiscussionsSubmitComponent,
    FormsAllComponent,
    FormsViewComponent,
    GroupsAllComponent,
    GroupsAll2Component,
    GroupsDetailComponent,
    GroupsResourceListComponent,
    GroupsUserListComponent,
    NewsFeedComponent,
    NotificationComponent,
    PostComponent,
    ProfileCertificatesComponent,
    ProfileChangePasswordComponent,
    ProfileChangeProfilePicturesComponent,
    ProfileConnectionsComponent,
    ProfileEditComponent,
    ProfileMyprofileComponent,
    ProfileUserDataComponent,
    ServicesDashboardComponent,
    ServicesSdrDetailsComponent,
    ServicesMandaysSummaryComponent,
    ServicesNewSdrComponent,
    ServicesPoComponent,
    ServicesSdrsComponent,
    StaticPageComponent,
    StoreInfoComponent,
    SupportCaseDetailComponent,
    SupportCasesComponent,
    SupportCaseSummaryComponent,
    SupportDashboardComponent,
    SupportGridComponent,
    SupportInstantHelpComponent,
    SupportNewAdvancedCaseComponent,
        SupportNewCaseComponent, PostListComponent,
        ProfileEditBoxComponent,
        ArticlesBoxComponent, MyAccountComponent,
        DiscussionsBoxComponent,
        ConnectionsBoxComponent, FollowerBoxComponent, ConnectionListComponent, TrainingBoxComponent, InternalRequestDetailsComponent, InternalRequestListComponent, InternalRequestSubmitComponent, GistecDashboardComponent, DocumentListComponent, UploadDocumentComponent, ContactSearchComponent, DocumentDetailComponent, DocumentShareToComponent, NotificationBoxComponent, AccessDeniedComponent, GoogleResponseComponent, ContinueWithComponent, SharedDocumentsComponent, SharedDocumentDetailComponent, RedirectDocumentComponent, SupportNewStandardComponent, LoginAsComponent, LoginAsMessageComponent
  ],
  imports: [
      BrowserModule, CommonModule, RouterModule, TagInputModule,
      FormsModule, DragulaModule.forRoot(),
      ReactiveFormsModule, SocialLoginModule,
      BrowserAnimationsModule, ImageCropperModule, QuillModule.forRoot(),
    OverlayModule, NgxMatIntlTelInputComponent, NgOtpInputModule,
      AppRoutingModule, OAuthModule.forRoot(),
      HttpClientModule, MatAutocompleteModule, NgPipesModule,
      MatBadgeModule,
      MatBottomSheetModule,
      MatButtonModule,
      MatButtonToggleModule,
      MatCardModule,
      MatCheckboxModule,
      MatChipsModule,
      MatStepperModule,
      MatDatepickerModule,
      MatDialogModule,
      MatDividerModule,
      MatExpansionModule,
      MatGridListModule,
      MatIconModule,
      MatInputModule,
      MatListModule,
      MatMenuModule,
      MatPaginatorModule,
      MatProgressBarModule,
      MatProgressSpinnerModule,
      MatRadioModule,
      MatSelectModule,
      MatSidenavModule,
      MatSliderModule,
      MatSlideToggleModule,
      MatSnackBarModule,
      MatSortModule,
      MatTableModule,
      MatTabsModule,
      ImageCropperModule,
      MatToolbarModule,
      MatTooltipModule,
      MatTreeModule,
    NgbModule,
    ToastrModule.forRoot(),
    AngularFireModule.initializeApp(environment.firebase),
    AngularFirestoreModule,
    AngularFireAuthModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      },
    }),
//     // for HttpClient use:
    LoadingBarHttpClientModule,
//     // for Router use:
    LoadingBarRouterModule,
//     // for Core use:
    LoadingBarModule
  ],
    providers: [AuthService, AdminGuard, SecureInnerPagesGuard, CookieService,
        CommonService, ArticlesService, AuthenticationService, DiscussionsService,
        DocumentService, EventEmitterService, FeedbackService, FollowersService, FormsService,
        GroupsService, InternalRequestService, PostsService, ProfileService, RequestService,
        ServicesService, StaticService, SupportService, ContactUsService, NavService,
        ChatService,
        LayoutService,
        TableService,
        DecimalPipe,

        {
            provide: 'SocialAuthServiceConfig',
            useValue: {
                autoLogin: false,
                providers: [
                    {
                        id: GoogleLoginProvider.PROVIDER_ID,
                        provider: new GoogleLoginProvider(
                            '132490776477-1p19pjh44jk4mu938qldm2kjkq1ua790.apps.googleusercontent.com'
                        )
                        
                    },
                    {
                        id: FacebookLoginProvider.PROVIDER_ID,
                        provider: new FacebookLoginProvider('224604742171682')
                    }
                ],
                onError: (err) => {
                    console.error(err);
                }
            } as SocialAuthServiceConfig,
        }

    ],
    exports: [
        NgbModule,
        FormsModule,
        ReactiveFormsModule,
        TranslateModule,
        LoaderComponent,
        BreadcrumbComponent,
        FeatherIconsComponent,
        TapToTopComponent,
        DisableKeyPressDirective,
        OnlyAlphabetsDirective,
        OnlyNumbersDirective,
        NgbdSortableHeader
    ],
  bootstrap: [AppComponent]
})
export class AppModule { }
